import { render, staticRenderFns } from "./TasksWeek.vue?vue&type=template&id=28bfbba9&scoped=true&"
import script from "./TasksWeek.vue?vue&type=script&lang=js&"
export * from "./TasksWeek.vue?vue&type=script&lang=js&"
import style0 from "./TasksWeek.vue?vue&type=style&index=0&id=28bfbba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfbba9",
  null
  
)

export default component.exports